module.exports = __webpack_public_path__ + "static/media/logo.e9723956.webp";